import type { BlockOpenQuestion } from 'shared-types';

type LocaleData = BlockOpenQuestion['locales'][string];

const defaultBlockData = {
  allowEditing: true,
  answertypes: ['text' as const],
  filetype: 'any' as const,
  grading: 'none' as const,
  isMandatory: false,
  pointsWeight: 0,
  requireAnswerToProceed: false,
  show_answers_after_submission: false
};

const translatable: LocaleData['translatable'] = {
  feedback: '',
  question: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  feedback: '{{ locales.translatable.feedback }}' as const,
  question: '{{ locales.translatable.question }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockOpenQuestionData: BlockOpenQuestion = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockOpenQuestion['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
